export function confirmTbaApproval(vm, action, service, items, onSuccess) {
  const ids = items.map((i) => i.id).filter((id) => id != null);
  if (!ids.length) return;

  const entity = (service?.singular || vm.$t("invoice")).toLowerCase();
  const plural = (service?.plural || `${entity}s`).toLowerCase();
  const verb = action === "approve" ? "approve" : "reject";
  const message =
    ids.length === 1
      ? `Are you sure you want to ${verb} this ${entity}?`
      : `Are you sure you want to ${verb} ${ids.length} ${plural}?`;

  vm.$confirm.require({
    dialogType: "confirm",
    message,
    requireReason: true,
    reasonRequired: action === "reject",
    service,
    accept: ({ reason } = {}) =>
      service.decide({ ids, action, reason }).then(() => {
        vm.$toast.add({
          severity: "success",
          detail:
          action === "approve"
          ? "Invoice has been approved successfully."
          : "Invoice has been rejected successfully.",
          life: 3000,
        });
        vm.emitter.emit("refresh-listing");
        vm.emitter.emit("refresh-tba-count");
        onSuccess?.(ids, action);
      }),
  });
}
